import React from 'react';
import { useSelector } from 'react-redux';

import { formatPhoneNumber } from 'app/design-system/components/PhoneInput/phone-input-helpers';
import { useTranslation } from 'app/lang';
import { selectClientProfilePhone } from 'app/lib/account/selectors';

import { PersonalItem } from '../../../PersonalItem';

import dictionary from './UserPhone.dictionary.json';

import styles from './UserPhone.module.scss';

export const UserPhone = () => {
  const { t } = useTranslation();
  const userPhone = useSelector(selectClientProfilePhone);

  if (!userPhone) {
    return null;
  }

  return (
    <div className={styles.root}>
      <PersonalItem label={t(dictionary.label)}
                    value={`+${formatPhoneNumber(userPhone)}`} />
    </div>
  );
};
